/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/BusinessSummarySpaAppsQuery$parameters.ts';
import type { BusinessSummarySpaAppsQuery } from './__generated__/BusinessSummarySpaAppsQuery.graphql.ts';
import { expValEquals } from '@atlassian/jira-feature-experiments';

type SummaryBusinessEntrypointComponent = EntryPointComponent<
	{
		summaryQuery: BusinessSummarySpaAppsQuery;
	},
	{},
	{},
	{}
>;

export const summaryBusinessEntrypoint: EntryPoint<
	SummaryBusinessEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<SummaryBusinessEntrypointComponent>(
		/* webpackChunkName: "async-summary-business-entrypoint" */ './BusinessSummarySpaApps.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				summaryQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
						scope: { project: { projectKey } },
						isFilterRefinementEnabled: expValEquals(
							'jira_add_harmonisation_filter_to_summary_view',
							'isEnabled',
							true,
							false,
						),
					},
				},
			},
		};
	},
});
